"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStudySubjectBlindActionResponse = exports.GetStudySubjectBlindActionResponse = exports.CreateStudySubjectBlindActionResponse = void 0;
class CreateStudySubjectBlindActionResponse {
}
exports.CreateStudySubjectBlindActionResponse = CreateStudySubjectBlindActionResponse;
class GetStudySubjectBlindActionResponse {
}
exports.GetStudySubjectBlindActionResponse = GetStudySubjectBlindActionResponse;
class UpdateStudySubjectBlindActionResponse {
}
exports.UpdateStudySubjectBlindActionResponse = UpdateStudySubjectBlindActionResponse;
//# sourceMappingURL=studySubjectBlindAction.js.map